import { defaultThemeName } from "../../config/defaults";
import { themeExists } from "../../assets/creator/themes";

// $1 has setttings content
const settingsRegex = /<Liquid[^>]*\bName=['"][^'"]*['"][^>]*>(?:(?!<\/Liquid>).)*?<Settings>([\s\S]+?)<\/Settings>/s;

/**
 * 
 * @param {string} xmlString 
 */
export function getLiquidSettings(xmlString) {
    const regexMatch = settingsRegex.exec(xmlString);

    if (!regexMatch) {
        return false;
    }
    let parsedSettings;
    try {
        parsedSettings = JSON.parse(regexMatch[1])
    } catch (e) {
        console.log("Not a valid JSON");
        return false;
    }
    if (parsedSettings instanceof Object) {
        const newSettings = {
            ...this.state.colorSettings,
            ...parsedSettings
        }
        let themeName = defaultThemeName;
        if (newSettings.themeName && themeExists(newSettings.themeName)) {
            themeName = newSettings.themeName;
        }
        this.setState({currentThemeName: themeName});
        this.handleSaveSettings(newSettings);
    }
	return true;
}